"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("./http");
const config_1 = require("./config");
class WPJWTAuth {
    constructor() {
        this.http = new http_1.default();
    }
    login(username, password, callback) {
        this.http.post(config_1.default.LOGIN, { username, password }, (response) => callback(response), null, false);
    }
    getUserData() {
        return localStorage.getItem("userData");
    }
}
exports.default = WPJWTAuth;
